import { useQuery } from "@tanstack/react-query";
import apiClient from "@/lib/apiClient";

export interface NavVisibility {
  home: boolean;
  encyclopedia: boolean;
  encyclopedia_articles: boolean;
  encyclopedia_faqs: boolean;
  assessments: boolean;
  consultations: boolean;
}

export interface NavSettings {
  nav_visibility: NavVisibility;
  nav_order: string[];
}

/**
 * 获取前台导航设置
 * 用于控制导航项的显示/隐藏和顺序
 */
export function useNavSettings() {
  return useQuery<NavSettings>({
    queryKey: ["navSettings"],
    queryFn: async () => {
      return apiClient<NavSettings>("/api/v1/site_settings/nav", {
        disableAutoToast: true,
      });
    },
    staleTime: 5 * 60 * 1000, // 5分钟缓存
    gcTime: 10 * 60 * 1000, // 10分钟垃圾回收
  });
}
